import React, { Fragment, memo } from 'react'

import CustomerSupportSection from './customer-support-section'
import HeaderSection from './header-section'
import MoneyBackGuaranteeSection from './money-back-guarantee-section'
import FooterSection from './footer-section'
import HeroSection from './hero-section'
import HowItWorksSection from './how-it-works-section'
import FAQSection from './faq-section'
import CustomerSupportFooterSection from './customer-support-footer-section'
import BenefitsSection from './benefits-section'
import TestimonialSection from './testimonials-section'
import {
    BenefitsSectionTransport,
    CustomerSupportFooterSectionTransport,
    CustomerSupportSectionTransport,
    FAQSectionTransport,
    FooterSectionTransport,
    HeaderSectionTransport,
    HeroSectionTransport,
    HowItWorksSectionTransport,
    MoneyBackGuaranteeSectionTransport,
    TestimonialsSectionTransport,
} from '@common/transports/deprecated-home-page-transport'

interface HomePageProps {
    headerSection: HeaderSectionTransport
    heroSection: HeroSectionTransport
    customerSupportSection: CustomerSupportSectionTransport
    benefitsSection: BenefitsSectionTransport
    testimonialsSection: TestimonialsSectionTransport
    howItWorksSection: HowItWorksSectionTransport
    moneyBackGuaranteeSection?: MoneyBackGuaranteeSectionTransport
    faqSection: FAQSectionTransport
    customerSupportFooterSection: CustomerSupportFooterSectionTransport
    footerSection: FooterSectionTransport
    isLoggedIn: boolean
}

const HomePage: React.FC<HomePageProps> = ({
    headerSection,
    heroSection,
    customerSupportSection,
    benefitsSection,
    testimonialsSection,
    howItWorksSection,
    moneyBackGuaranteeSection,
    faqSection,
    customerSupportFooterSection,
    footerSection,
    isLoggedIn,
}) => (
    <Fragment>
        <HeaderSection headerSection={headerSection} isLoggedIn={isLoggedIn} />
        <main>
            <HeroSection heroSection={heroSection} isLoggedIn={isLoggedIn} />
            <CustomerSupportSection customerSupportSection={customerSupportSection} />
            <BenefitsSection benefitsSectionData={benefitsSection} />
            <TestimonialSection testimonialsSectionData={testimonialsSection} />
            <HowItWorksSection howItWorksSection={howItWorksSection} isLoggedIn={isLoggedIn} />
            {!!moneyBackGuaranteeSection && (
                <MoneyBackGuaranteeSection moneyBackGuaranteeSection={moneyBackGuaranteeSection} />
            )}
            <FAQSection faqSection={faqSection} />
            <CustomerSupportFooterSection
                customerSupportFooterSection={customerSupportFooterSection}
                isLoggedIn={isLoggedIn}
            />
        </main>
        <FooterSection footerSection={footerSection} />
    </Fragment>
)

export default memo(HomePage)
